import axios from "axios";

const options = {
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
}
const API = axios.create(options)

API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('user_token');
    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export default API

